export const DEFAULT_BANNER_URL = 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=1200&q=80'; // Abstract gradient
